import { modals, MenuItem } from '@cad-arc';
import { MaLeapsPasswordModal } from './ma-leaps-password-modal';
import { UseMaLeapsPasswordReturn } from '../use-dex-password-api';

export const MaLeapsPassword = ({
    leapsPasswordInfo,
}: {
    leapsPasswordInfo: UseMaLeapsPasswordReturn;
}) => {
    return (
        <MenuItem
            leadingVisual={!leapsPasswordInfo.doesHavePassword ? 'ExclamationPoint' : undefined}
            onClick={() => {
                modals.blank({
                    children: ({ onClose }) => (
                        <MaLeapsPasswordModal
                            onClose={onClose}
                            leapsPasswordInfo={leapsPasswordInfo}
                        />
                    ),
                });
            }}
        >
            Set MA LEAPS Password
        </MenuItem>
    );
};
